export default "__VITE_ASSET__M9vBt0Zr__"